// actions
import ACTIONS from "../../constants/actions";

const { GET_ALL_BRANCH_ORG } = ACTIONS;

export function metaDataOrg(allBranch) {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_BRANCH_ORG,
      payload: allBranch,
    });
  };
}
